import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatButtonModule } from '@angular/material/button';
import { TranslocoPipe, TranslocoModule } from '@ngneat/transloco';

export interface ShareLevelDialogDataFile {
  shareLevel: string;
  shareLevelEdit: string;
  fileName: string;
}

@Component({
  standalone: true,
  selector: 'app-share-level-dialog-file',
  styleUrls: ['./share-level-dialog.component-file.scss'],
  templateUrl: './share-level-dialog.component-file.html',
  providers: [TranslocoPipe],
  imports: [MatDialogModule, MatFormFieldModule, MatSelectModule, MatCheckboxModule, MatButtonModule, TranslocoModule]
})
export class ShareLevelDialogComponentFile {
  constructor(
    public dialogRef: MatDialogRef<ShareLevelDialogComponentFile>,
    @Inject(MAT_DIALOG_DATA) public data: ShareLevelDialogDataFile
  ) {}

  onCancel(): void {
    this.dialogRef.close(null);
  }

  onConfirm(): void {
    this.dialogRef.close({
      shareLevel: this.data.shareLevel,
      shareLevelEdit: this.data.shareLevelEdit
    });  }
}
